import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { useTpslModalOverlay } from '../../../tpsl-modal/use-tpsl-modal-overlay';
import { tradingSessionCheckBunja } from '../../trading-suspension/state';
import type { TpslButtonStateProps } from './identity';
import { tpslButtonBunja } from './state';

interface ManageClickParams
  extends Pick<
    TpslButtonStateProps,
    'tpslType' | 'marginType' | 'accountId' | 'tradeMode' | 'canLimitTpsl' | 'proceedToAdjustTpsl' | 'onClick'
  > {
  /**
   * true면 모달을 열기 전 거래 가능 여부를 확인한다(불가 시 onClick만 실행하고 중단).
   * 미설정·단일(count ≤ 1)에서만 가드하고, 복수(count > 1)에서는 항상 관리 모달을 연다.
   */
  guardTradable: boolean;
}

/**
 * TP/SL 관리 모달을 여는 클릭 핸들러. 각 상태 컴포넌트가 자기 클릭 동작을 소유하도록 공유한다.
 * 식별자·slot은 tpslButtonBunja(Context 스코프)에서 구독하고, 모달 오버레이·거래가능 체크 훅을
 * 자체 세팅하므로 컨테이너가 이 배선을 들고 있지 않는다.
 */
export const useTpslManageClick = ({
  tpslType,
  marginType,
  accountId,
  tradeMode,
  canLimitTpsl,
  guardTradable,
  proceedToAdjustTpsl,
  onClick,
}: ManageClickParams): (() => void) => {
  const { symbolAtom, positionTypeAtom, parentIdAtom, slotAtom } = useBunja(tpslButtonBunja);
  const symbol = useAtomValue(symbolAtom);
  const positionType = useAtomValue(positionTypeAtom);
  const parentId = useAtomValue(parentIdAtom);
  const slot = useAtomValue(slotAtom);

  const { checkTradable } = useBunja(tradingSessionCheckBunja);
  const { openTpslModal } = useTpslModalOverlay(
    symbol,
    positionType,
    tpslType,
    slot,
    marginType,
    parentId,
    accountId,
    tradeMode,
    canLimitTpsl,
  );

  return () => {
    if (guardTradable && !checkTradable()) {
      onClick?.();
      return;
    }
    if (proceedToAdjustTpsl && !proceedToAdjustTpsl()) return;
    openTpslModal();
    onClick?.();
  };
};
